// extracted by mini-css-extract-plugin
export var box = "_5g-1";
export var checkboxRow = "_5g-8";
export var checked = "_5g-2";
export var descriptionSpacer = "_5g-a";
export var disabled = "_5g-3";
export var icon = "_5g-6";
export var input = "_5g-0";
export var labelSpacer = "_5g-9";
export var medium = "_5g-5";
export var small = "_5g-4";
export var text = "_5g-7";